import { render, staticRenderFns } from "./flpSettingTab.vue?vue&type=template&id=5f6ee5fa&scoped=true&"
import script from "./flpSettingTab.vue?vue&type=script&lang=js&"
export * from "./flpSettingTab.vue?vue&type=script&lang=js&"
import style0 from "./flpSettingTab.vue?vue&type=style&index=0&id=5f6ee5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ee5fa",
  null
  
)

export default component.exports